<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <a @click="toModifyPage">修改</a>
        <a @click="toBusinessManagement">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">姓名：</span>
        </div>
        <el-input v-model="formData.personName" :maxlength="24" size="small" style="width: 280px" disabled />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">性别：</span>
        </div>
        <div style="display: inline-block">
          <el-radio-group v-model="formData.sex" style="width: 280px" size="small" disabled>
            <el-radio-button label="0">男</el-radio-button>
            <el-radio-button label="1">女</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">手机号：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" :maxlength="11" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">身份证号：</span>
        </div>
        <el-input v-model="formData.identityNumber" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">申请房型：</span>
        </div>
        <el-select v-model="formData.rentType" placeholder="请选择" size="mini" style="width: 280px" disabled>
          <el-option v-for="item in rentTypeList" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">预入住日期：</span>
        </div>
        <el-date-picker v-model="formData.stayStartTime" type="date" size="small" style="width: 280px" :editable=false value-format="yyyy-MM-dd" placeholder="选择日期" disabled></el-date-picker>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">预租期限：</span>
        </div>
        <el-select v-model="formData.leaseTimeLimit" placeholder="请选择" size="mini" style="width: 280px" disabled>
          <el-option v-for="item in leaseTimeLimitList" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.remarks" size="small" style="width: 280px" disabled/>
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import {api} from '../../api/LeaseManage'
  import {errorHandler} from '../../../utils/errorHandler'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TextTitle,
      Breadcrumb},
    name: 'lessee-current',
    data () {
      return {
        yqCode: '',
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: '个人承租'
        }],
        mainTitle: '查看承租人',
        subheading: '',
        rentTypeList: [
          {key: 0, label: '整租'},
          {key: 1, label: '床位'}
        ],
        leaseTimeLimitList: [
          {key: '一个月', label: '一个月'},
          {key: '三个月', label: '三个月'},
          {key: '半年', label: '半年'},
          {key: '一年', label: '一年'},
          {key: '一年以上', label: '一年以上'},
        ],
        formData: {},
        currentCode: ''
      }
    },
    created () {
      this.yqCode = bus.global.yqCode
      this.currentCode = this.$route.params.id
      this.getPersonLeaseByCode()
    },
    methods: {
      toBusinessManagement () {
        this.$router.push({
          name: 'lessee-management'
        })
      },
      toModifyPage () {
        this.$router.push({
          path: `/lessee_modify/${this.currentCode}`
        })
      },
      getPersonLeaseByCode () {
        this.$axios.get(`${api.getPersonLeaseByCode}/${this.currentCode}`, {})
          .then(res => {
            let data = res.data.data
            this.formData = data
          })
          .catch(errorHandler('查询人员失败'))
      }
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
    position: relative;
  }
  form .photoBox {
    width: 120px;
    height: 160px;
    border: 1px dashed #dcdfe6;
    border-radius: 5px;
    position: absolute;
    left: 450px;
    top: 0;
  }
  .photoBox img {
    width: 100%;
    height: 100%;
  }
  .photoBox p {
    color: #999999;
    font-size: 12px;
    line-height: 160px;
    text-align: center;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 120px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/LesseeManage/LesseeCurrent.vue